import React from "react";
import { useSupplyReportStore } from "../../stores/supplyReportStore";
import { SearchBar, RefreshButton } from "components";
import SupplyReportFilterPanel from "./SupplyReportFilterPanel";

// Компонент заголовку сторінки з панеллю пошуку та фільтрації
const SupplyReportHeader = () => {
  const isLoading = useSupplyReportStore((state) => state.isLoading);
  const fetchData = useSupplyReportStore((state) => state.fetchData);
  const filters = useSupplyReportStore((state) => state.filters);
  const setSearch = useSupplyReportStore((state) => state.setSearch);

  return (
    <div className="supplyreportpage-title">
      <div className="supplyreportpage-title-line">
        <div className="title-container">
          <RefreshButton onRefresh={fetchData} disabled={isLoading} />
          <h3>Очікуваний прихід</h3>

          <div className="search-container">
            <SearchBar value={filters.search} onSearch={(value) => setSearch(value)} />
          </div>
        </div>
      </div>

      <div className="supplyreportpage-title-line">
        <SupplyReportFilterPanel />
      </div>
    </div>
  );
};

export default SupplyReportHeader;
